<template>
  <div
    class="splash"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="splash__spacer" aria-hidden="true" />

    <div class="splash__center">
      <img
        class="splash__logo"
        :src="logoSrc"
        alt="VWELL"
        width="240"
        height="102"
      >
      <p class="splash__product">CMS</p>
      <div class="splash__progress">
        <v-progress-linear
          indeterminate
          color="white"
          background-color="white"
          :background-opacity="0.24"
          height="3"
          rounded
        />
      </div>
      <p class="splash__status">กำลังเข้าสู่ระบบ…</p>
    </div>

    <p class="splash__footer">ระบบบริหารจัดการสถานพยาบาล</p>
  </div>
</template>

<script>
export default {
  name: 'SplashContainer',
  data () {
    return {
      logoSrc: require('@/assets/logo-text.png')
    }
  }
}
</script>

<style scoped>
.splash {
  position: fixed;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 48px 24px 32px;
  background: linear-gradient(160deg, #2f2f88 0%, #1a1a5c 100%);
  color: #fff;
}

.splash__spacer {
  height: 24px;
}

.splash__center {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: splash-enter 300ms ease-out;
}

.splash__logo {
  display: block;
  width: 240px;
  max-width: 70vw;
  height: auto;
  margin-bottom: 16px;
}

.splash__product {
  margin: 8px 0 0;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.4em;
  color: rgba(255, 255, 255, 0.72);
}

.splash__progress {
  width: 200px;
  max-width: 100%;
  margin-top: 32px;
}

.splash__status {
  margin: 16px 0 0;
  font-size: 1rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.78);
}

.splash__footer {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.58);
}

@keyframes splash-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .splash__center {
    animation: none;
  }
}
</style>
